import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { SaveMetaMilestoneForm } from 'modules/components/layer12';

export type SaveMetaMilestoneModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveMetaMilestoneModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save meta milestone'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveMetaMilestoneForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
